import * as yup from 'yup';
import i18n from 'i18next';

const REGEX_PASSWORD =
  /^(((?=.\d)(?=.[a-z])(?=.[A-Z]))|((?=.\d)(?=.[a-z]))|((?=.\d)(?=.[A-Z]))|((?=.[a-z])(?=.*[A-Z]))).{6,24}$/;
const REGEX_DIGITS = /\d/;

export const schemaResetPassword = yup.object().shape({
  username: yup.string().required(i18n.t('auth.formResetPassword.validationSchema.username')),
});

export const schemaNewPassword = yup.object().shape({
  password: yup
    .string()
    .required(i18n.t('auth.formNewPassword.validationSchema.required'))
    .min(8, i18n.t('auth.formNewPassword.validationSchema.newPassword'))
    .matches(REGEX_PASSWORD, i18n.t('auth.formNewPassword.validationSchema.newPassword'))
    .matches(REGEX_DIGITS, i18n.t('auth.formNewPassword.validationSchema.newPassword')),
  password2: yup
    .string()
    .required(i18n.t('auth.formNewPassword.validationSchema.required'))
    .test(
      'passwordMatch',
      i18n.t('auth.formNewPassword.validationSchema.matchError'),
      (value, context) => value === context.parent.password,
    ),
});
